import { render, staticRenderFns } from "./DeliveryPlanCell.vue?vue&type=template&id=19f727de&scoped=true"
import script from "./DeliveryPlanCell.vue?vue&type=script&lang=js"
export * from "./DeliveryPlanCell.vue?vue&type=script&lang=js"
import style0 from "./DeliveryPlanCell.vue?vue&type=style&index=0&id=19f727de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f727de",
  null
  
)

export default component.exports